import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper';
import useMediaQuery from '../../../utils/hooks/mediaQuery.hook';
import ImageContainer from '../../../components/ImageContainer';

import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';

import ImagePlaceholder from '../../../assets/images/image-placeholder.svg';
import { IDimensions } from '../../../components/interfaces/IImageContainer';

const swiperModules = [Navigation, Pagination];

interface Props {
  imageUrls?: Array<string | null> | null
  imageSize?: IDimensions
  showNavigation?: boolean
  onImageClick?: () => void
  alt: string
}

const ImageCarousel = ({
  imageUrls = [],
  imageSize,
  showNavigation: show = true,
  onImageClick,
  alt,
} : Props) => {
  const { isMobile } = useMediaQuery();

  const hasMultipleImages = imageUrls ? imageUrls?.length > 1 : false;

  const showNavigation = show && hasMultipleImages && !isMobile;

  const cloudinaryParams = ['c_pad'];

  const pagination = {
    clickable: hasMultipleImages,
  };

  const images = imageUrls?.length ? imageUrls?.map((image) => (
    <SwiperSlide key={image} onClick={onImageClick}>
      <ImageContainer
        src={image || undefined}
        className="rounded"
        size={imageSize}
        params={cloudinaryParams}
        alt={alt}
      />
    </SwiperSlide>
  )) : (
    <div onClick={onImageClick} role="none" className="d-flex justify-content-center">
      <ImageContainer
        placeholder={ImagePlaceholder}
        className="rounded"
        size={imageSize}
        params={cloudinaryParams}
        alt={alt}
      />
    </div>
  );

  return (
    <div className="position-relative">
      <Swiper
        modules={swiperModules}
        slidesPerView={1}
        navigation={showNavigation}
        pagination={pagination}
        loop={hasMultipleImages}
      >
        {images}
      </Swiper>
    </div>
  );
};

export default ImageCarousel;
